<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="fi_10629607">
      <g id="Group">
        <path
          id="Vector"
          d="M38.75 20C38.75 21.6 36.7844 22.9187 36.3906 24.3937C35.9844 25.9187 37.0125 28.0438 36.2406 29.3781C35.4562 30.7344 33.0969 30.8969 31.9969 31.9969C30.8969 33.0969 30.7344 35.4562 29.3781 36.2406C28.0438 37.0125 25.9187 35.9844 24.3937 36.3906C22.9187 36.7844 21.6 38.75 20 38.75C18.4 38.75 17.0812 36.7844 15.6062 36.3906C14.0812 35.9844 11.9563 37.0125 10.6219 36.2406C9.26562 35.4562 9.10313 33.0969 8.00313 31.9969C6.90313 30.8969 4.54375 30.7344 3.75937 29.3781C2.9875 28.0438 4.01562 25.9187 3.60938 24.3937C3.21563 22.9187 1.25 21.6 1.25 20C1.25 18.4 3.21563 17.0812 3.60938 15.6062C4.01562 14.0812 2.9875 11.9563 3.75937 10.6219C4.54375 9.26562 6.90313 9.10313 8.00313 8.00313C9.10313 6.90313 9.26562 4.54375 10.6219 3.75937C11.9563 2.9875 14.0812 4.01562 15.6062 3.60938C17.0812 3.21563 18.4 1.25 20 1.25C21.6 1.25 22.9187 3.21563 24.3937 3.60938C25.9187 4.01562 28.0438 2.9875 29.3781 3.75937C30.7344 4.54375 30.8969 6.90313 31.9969 8.00313C33.0969 9.10313 35.4562 9.26562 36.2406 10.6219C37.0125 11.9563 35.9844 14.0812 36.3906 15.6062C36.7844 17.0812 38.75 18.4 38.75 20Z"
          fill="#00A8E8"
        />
        <path
          id="Vector_2"
          d="M25.4195 14.4124L18.282 21.5499L14.582 17.853C13.7789 17.0499 12.4758 17.0499 11.6727 17.853C10.8695 18.6562 10.8695 19.9593 11.6727 20.7624L16.8633 25.953C17.6445 26.7343 18.9133 26.7343 19.6945 25.953L28.3258 17.3218C29.1289 16.5187 29.1289 15.2155 28.3258 14.4124C27.5227 13.6093 26.2227 13.6093 25.4195 14.4124Z"
          fill="#FFFCEE"
        />
      </g>
    </g>
  </svg>
</template>
